<template>
    <CompassFeatureModal
        class="upsell-modal"
        :visible.sync="showModal"
        :title="getTitle"
        variant="upsell"
        :primaryAction="getPrimaryAction"
        @closed="$emit('close')"
    >
        <template #header>
            <img :src="getSource" />
        </template>
        {{ getDescription }}
    </CompassFeatureModal>
</template>

<script>
import Feature from 'Services/Feature';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    props: {
        feature: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'upsell',
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        ...mapStateUser(['isAdmin']),
        getTitle() {
            switch (this.type) {
                case 'upsell-ai': {
                    return this.$t.__('upsell.UpsellFeatureModal.title_ai');
                }
                case 'upsell':
                default:
                    return this.$t.__('UpsellFeatureModal.move_to_higher_speed');
            }
        },
        getPrimaryAction() {
            if (this.type === 'upsell-ai' && !this.isAdmin) {
                return;
            }
            return {
                label: this.$t.__('common.actions.contact_sales'),
                action: this.handleAction,
                dataBot: this.feature,
            };
        },
        getDescription() {
            switch (this.type) {
                case 'upsell-ai': {
                    return this.isAdmin
                        ? this.$t.__('upsell.UpsellFeatureModal.description_ai')
                        : this.$t.__('upsell.UpsellFeatureModal.description_ai.collaborator');
                }
                case 'upsell':
                default:
                    return this.$t.__('UpsellFeatureModal.move_to_higher_speed_description');
            }
        },
        getSource() {
            switch (this.type) {
                case 'upsell-ai': {
                    return '/ressources/logged/img/illustrations/pricing-illustration.svg';
                }
                case 'upsell':
                default:
                    return '/ressources/logged/img/illustrations/modal-services-upgrade-plan.svg';
            }
        },
    },
    mounted() {
        this.showModal = true;
    },
    methods: {
        handleAction() {
            if (Feature.isEnabled('intercom')) {
                window.Intercom('show');
            }
        },
    },
};
</script>

<style>
.compass-feature-modal.upsell-modal {
    z-index: 1000;
}
</style>
